import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin';
import { Categorie } from 'model/categorie';

@Component({
  selector: 'app-gestion-medicament-entrepot',
  templateUrl: './gestion-medicament-entrepot.component.html',
  styleUrls: ['./gestion-medicament-entrepot.component.scss']
})
export class GestionMedicamentEntrepotComponent implements OnInit {
  mode_entrepot: number = 1;
  pageMedicament:any;
  pageCons:any;
  pageConsDentisterie : any;
  pageConsSoins : any;
  pageConsLabo : any;

  motCle:String="";
  motCleMed:String="";
    motCleDent:String="";
    motCleSoins:String="";
    motCleConsEC:String="";
  page:number=1;
  currentPage : number=1;
  size:number=10;
  pageFournisseur:any;
ongletcmd :String="CP";
   role_user:any;
  currentPageConsEC : number=1;
  currentPageConsDent : number =1;
  currentPageConsSoins : number =1;
  pages:Array<number>;
   pagesConsDent:Array<number>;
    pagesConsEC:Array<number>;
     pagesConsSoins:Array<number>;
pagecourant : number=1;
     onglet:String="CS";
     private categories:Categorie[];

  constructor(public adminService: AdminService) { }

  ngOnInit() {
    this.rechecheMed();
   this.rechecheConsDentisterie();
   this.rechecheConsEC();
   this.rechecheConsSoins();
  }

  open(id: any) {
    if (id == 1) {
      this.mode_entrepot=1;
      ///Produits disponibles
    } else {
     // Destockage urgent
     this.mode_entrepot=2;
    }
  }



  rechecheMed(){
    this.adminService.getListMedicaments(this.motCleMed, this.size, this.currentPage)
    .subscribe((data)=>{
      console.log(data);
      this.pageMedicament=data;
      //this.pages=new Array(data.totalPages);
      if (data && data[0].infoEnregistrement.totalPages)
          this.pages = new Array(data[0].infoEnregistrement.totalPages);
        else this.pages = new Array(0);
        console.log("taille pages "+this.pages.length);
    },(error)=>{
      console.log(error);
    });
  }

  rechecheCons(){
    this.adminService.getConsBymotCle(this.motCle, this.size, null)
    .subscribe((data)=>{
      console.log(data);
      this.pageCons=data;
      //this.pages=new Array(data.totalPages);
    },(error)=>{
      console.log(error);
    });
  }


    rechecheConsDentisterie(){
    this.adminService.getListConsDentisterie(this.motCleDent, this.size, this.currentPageConsDent)
    .subscribe((data)=>{
      console.log(data);
      this.pageConsDentisterie=data;
      if (data && data[0].infoEnregistrement.totalPages)
          this.pagesConsDent = new Array(data[0].infoEnregistrement.totalPages);
        else this.pagesConsDent = new Array(0);
      //this.pages=new Array(data.totalPages);
    },(error)=>{
      console.log(error);
    });
  }

      rechecheConsSoins(){
    this.adminService.getListConsSoin(this.motCleSoins, this.size, this.currentPageConsSoins)
    .subscribe((data)=>{
      console.log(data);
      this.pageConsSoins=data;
      if (data && data[0].infoEnregistrement.totalPages)
          this.pagesConsSoins = new Array(data[0].infoEnregistrement.totalPages);
        else this.pagesConsSoins = new Array(0);
      //this.pages=new Array(data.totalPages);
    },(error)=>{
      console.log(error);
    });
  }

      rechecheConsLabo(){
    this.adminService.getListConsLab(this.motCle, this.size, null)
    .subscribe((data)=>{
      console.log(data);
      this.pageConsLabo=data;
      //this.pages=new Array(data.totalPages);
    },(error)=>{
      console.log(error);
    });
  }

   rechecheConsEC(){
    this.adminService.getListConsEC(this.motCleConsEC, this.size, this.currentPageConsEC)
    .subscribe((data)=>{
      console.log(data);
      this.pageConsLabo=data;
      if (data && data[0].infoEnregistrement.totalPages)
          this.pagesConsEC = new Array(data[0].infoEnregistrement.totalPages);
        else this.pagesConsEC = new Array(0);
      //this.pages=new Array(data.totalPages);
    },(error)=>{
      console.log(error);
    });
  }

  chercherMed(){
    this.rechecheMed();
  }
  chercherCons(){
    this.rechecheCons();
  }

  recupererLibelleType(type_code){
    return this.adminService.getLibelleType(type_code);
  }

  recupererLibelleCategorie(categorie : Categorie){
    if(categorie)return categorie.categorie_libelle;
    return "";
  }




  gotoPage(i:number) {
    if(i<1)return;
    if(i>this.pages.length)return;
    this.currentPage=i;
    this.rechecheMed();
  }

  gotoPageConsSoins(i:number) {
    if(i<1)return;
    if(i>this.pagesConsSoins.length)return;
    this.currentPageConsSoins=i;
    this.rechecheConsSoins();
  }
   gotoPageConsDent(i:number) {
    if(i<1)return;
    if(i>this.pagesConsDent.length)return;
    this.currentPageConsDent=i;
    this.rechecheConsDentisterie();
  }

  gotoPageConsEC(i:number) {
    if(i<1)return;
    if(i>this.pagesConsEC.length)return;
    this.currentPageConsEC=i;
    this.rechecheConsEC();
  }

}
